module.exports = __webpack_public_path__ + "static/media/service.a2dbfb51.png";